const getters = {
  dangerList: state => state.dangerList,
  loading: state => state.loading,
  cameraInfo: state => state.cameraInfo
}
export default getters